// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__lGyCJ"};